import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function assertNever(x) {
    throw new Error(`${x} is not of type never. This should never happen.`);
}
export function assertNeverAndIgnore(_x) {
    // Intentionally empty.
}
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map